import React from 'react';
import PropTypes from 'prop-types';

const ImageView = ({ image }) => {
  return (
    <div>
      <img
        src={image.imageLink}
        alt={image.text || ''}
        className={'thumbnail mx-auto d-block mb-2'}
        onClick={() => window.open(image.imageLink, '_blank')}
      />
    </div>
  );
};

ImageView.propTypes = {
  image: PropTypes.object,
};

export default ImageView;



// WEBPACK FOOTER //
// ./src/components/common/ImageView.js